export const iconFontAwesomeMedicalHealthBandage = (
	<i className="fa-solid fa-bandage"></i>
);
